import React, { useRef, useState, useEffect } from "react";
import {Swiper, SwiperSlide, } from "swiper/react";
import { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import './carousel.less';


// 轮播参数
interface CarouselProps {
	data: string[]; // 图片地址列表
	speed?: number; // // 轮播速度，默认2秒
	className?: string;
}


const Carousel = (props: CarouselProps) => {
	const { speed = 2, data } = props;
	const banners = Array.isArray(data) ? data : [];
	const [scrollHeight, setScrollHeight] = useState<number>(0);
	const scrollContainerRef = useRef<any>(null);


	// 初始化滚动高度,和宽度比例为4：3
	useEffect(() => {
		if (scrollContainerRef.current) {
			setScrollHeight(scrollContainerRef.current.clientWidth * 0.75);
		}
	}, [scrollContainerRef.current]);


	return (
		<div className="banner-carousel-wrapper" ref={scrollContainerRef} style={{height: scrollHeight || 260}}>
			<Swiper
				className="h"
				modules={[Navigation, Pagination, Autoplay]}
				navigation={true}
				pagination={{ clickable: true }}
				autoplay={{delay: speed * 1000, disableOnInteraction: false}}
				loop={true}
				allowTouchMove={false}
			>
				{
					banners.map((imgSrc) => (
						<SwiperSlide key={imgSrc} className="h">
							<div className="banner-content h flexic flexjc">
								<img src={imgSrc} loading="lazy" />
							</div>
						</SwiperSlide>
					))
				}
			</Swiper>
		</div>
	)
}


export default Carousel;
